import styled from "@emotion/styled";
import Colors from "styles/colors";
import { titleFontSizes } from "/segments/desktop/core-components/title/consts";
const MIN_WIDTH = '250px';
const MAX_WIDTH = '400px';
const DIVIDER_BORDER_THICKNESS = '1px';
const DIVIDER_BACKGROUND_COLOR = 'grey';
export const StyledAssetContentCard = styled.div`
  display: flex;
  flex-direction: column;
  border-style: solid;
  border-radius: ${({ borderRadius })=>borderRadius};
  border-width: ${({ borderThickness })=>borderThickness};
  border-color: ${({ borderColor })=>Colors[borderColor]};
  padding: ${({ cardPadding })=>cardPadding};

  width: fit-content;
  min-width: ${({ minWidth })=>minWidth || MIN_WIDTH};
  max-width: ${({ maxWidth })=>maxWidth || MAX_WIDTH};
  flex-shrink: 1;

  .asset-wrapper {
    margin-bottom: ${({ assetBottomMargin })=>assetBottomMargin};
  }

  .content-wrapper {
    padding: ${({ contentPadding })=>contentPadding};
  }

  .title-wrapper {
    font-size: ${({ titleFontSize })=>titleFontSizes[titleFontSize]};
    font-weight: ${({ titleFontWeight })=>titleFontWeight};
    margin-bottom: ${({ titleBottomMargin })=>titleBottomMargin};
  }

  .pills-container {
    position: relative;
    overflow: hidden;
  }

  .pills-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    position: relative;
    z-index: 1;
  }

  .hover-button-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    display: flex;
    align-items: flex-end;
    transform: translateY(100%);
    transition: transform 0.3s ease-in-out;
    z-index: 2;
    padding: ${({ buttonPadding })=>buttonPadding};

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: ${({ dividerConfig })=>(dividerConfig === null || dividerConfig === void 0 ? void 0 : dividerConfig.borderThickness) || DIVIDER_BORDER_THICKNESS};
      background-color: ${({ dividerConfig })=>(dividerConfig === null || dividerConfig === void 0 ? void 0 : dividerConfig.backgroundColor) ? Colors[dividerConfig.backgroundColor] : DIVIDER_BACKGROUND_COLOR};
      transform: translateY(100%);
      transition: transform 0.3s ease-in-out;

      :hover {
        transform: translateY(0);
      }
    }
  }

  &:hover {
    .hover-button-wrapper {
      transform: translateY(0);
    }
  }
`;
